import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  dAPI_Delete_Ingetration,
  putAPI_Update_OnOff,
} from '../../../../../../constants/APIs';
import MessengerX from '../../../../../../assets/Website icon.png';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';

export default function HelpCenterIntegrationThumb({
  integration,
  allProperties,
  LoadIntegrations,
  locale
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState('');
  const [moreProperties, setMoreProperties] = useState('');
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
    !integration.disabled
  );
  useEffect(() => {
    const result = integration.properties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    // console.log(result)
    if (result.length > 2) {
      const filterResults = result.slice(0, 2);
      // console.log(filterResults)
      setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
      setMoreProperties(
        'and ' + (result.length - filterResults.length) + ' more'
      );
    } else {
      const filterResults = result.filter((elem) => elem !== undefined);
      //console.log(filterResults)
      setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
    }
  }, [integration, allProperties]);

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integration.id
        }/?group_id=${getGroupID()}`,
    }).then((res) => {
      toggle();
      LoadIntegrations();
    });
  };
  const handleOnOff = (onoff) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
      data: { disabled: onoff },
    }).then((res) => {
      console.log('on/off');
    });
  };

  const handleSwitchChange = (value) => {
    //console.log(value)
    setCheckedPrimarySmall(value);
    handleOnOff(!value);
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This action will permanently remove the integration. Are you sure you want to delete the integration?
                </ModalHeader>
                <ModalBody className="d-flex justify-content-space-between">
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Go Back
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Confirm
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const getName = (assistantDetail) => {
    if (assistantDetail !== null && assistantDetail.length > 0) {
      var findIndex = assistantDetail.findIndex(i => i.locale === locale);
      if (findIndex === -1) {
        var getEn = assistantDetail.filter(c => c.locale === "en");
        if (getEn !== null && getEn.length > 0) {
          return getEn[0].name;
        }
        else {
          return "";
        }
      }
      else {
        return assistantDetail[findIndex].name;
      }
    }
    else {
      return "";
    }
  }
  return (
    <Fragment>
      {integration ? (
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card className="d-flex flex-row" style={{ height: '215px' }}>
            <div>
              <h3 className="integrationChannel">
                <img
                  src={MessengerX}
                  alt="Logo"
                  style={{ maxWidth: '40px' }}
                />
              </h3>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small integrationremove"
                checked={checkedPrimarySmall}
                onChange={(primary) => handleSwitchChange(primary)}
              />
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-3">
                  <NavLink
                    to={{
                      pathname:
                        '/app/pages/helpcenter-integrationdetail/' + integration.id,
                    }}
                    key={integration.id}
                  >
                    <div className="text-center">
                      <CardImg
                        top
                        src={
                          integration.botSettings
                            ? integration.botSettings.urls.icon
                            : ''
                        }
                        alt="Card image cap"
                        className="img-thumbnail border-0 rounded-circle list-thumbnail"
                      />
                      <div className="mb-1">
                        {integration.botSettings
                          ? getName(integration.botSettings.assistantDetails)
                          : ''}
                      </div>
                      <div className="mb-1">
                        {integration ? integration.name : null}
                      </div>
                      <div className="mb-2">
                        <b>{formatedProperties} </b>

                        <b>{moreProperties}</b>
                      </div>
                      {/* <div className="mb-1">
                        <h3 className="simple-icon-eye m-2" />
                      </div> */}
                    </div>
                  </NavLink>
                </Colxx>
              </Row>
            </CardBody>
            <div className='integrationdelete'>
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ color: 'var(--theme-color-1)' }}
                cursor="pointer"
                onClick={toggle}
              />
            </div>
          </Card>
        </Colxx>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
